import React, { useEffect, useState } from "react";
import Loader from "../../general/Loader";
import { formatCurrency, getLink } from "../../../utils/helpers";
import { Link, useParams } from "react-router-dom";
import { request } from "../../../utils/request";
import Pagination from "../../general/Pagination";
import useFilters from "../../../hooks/useFilters";
import Select from "react-select";
import { apiRequest } from "../../../hooks/apiRequest";

const Gastos = ({vehiculo}) => {
    const [gastos, setGastos] = useState({});
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const { handleFilterChange, filtersQuery } = useFilters({});
    const { id } = useParams();

    const getGastos = async (url = null) => {
        setLoading(true);
        url = url ? url : `gastos-internos?limit=50&vehiculo=${id}`;

        const gastos = await request(url);
        setGastos(gastos);
        setLoading(false);
    };

    const getOptions = async (url = null, search = null, label = 'nombre', value = 'id') => {
        const table = await apiRequest({}, url, 'get');
        if (table.data) {
            return table.data.map(item => ({value: item[value], label: item[label]})).filter((item) => {
                return search ? item.label.toLowerCase().includes(search.toLowerCase()) : true
            });
        }
    };

    const onFilterChange = (value, filtro) => {
        handleFilterChange(filtro, value instanceof Array ? value.map((v) => v.value).join(",") : value);
    };

    useEffect(() => {
        getOptions("taxonomias?relacion=gastos").then(setCategorias);
        getGastos(`gastos-internos${filtersQuery}&limit=50&vehiculo=${id}`);
    }, []);

    useEffect(() => {
        getGastos(`gastos-internos${filtersQuery}&limit=50&vehiculo=${id}`);
    }, [filtersQuery]);

    return (
        <div>
            <div className='row m-b-20'>
                <div className='col-4'>
                    <h3>Historial de Gastos Realizados </h3>
                </div>
                <div className='col d-flex'>
                    <Select
                        id="categoria"
                        options={categorias}
                        name="categoria"
                        className="mr-2 ml-auto vehiculo-historial-select"
                        isMulti
                        isClearable
                        placeholder="Todas"
                        onChange={(values) =>
                            onFilterChange(values, "categorias")
                        }
                    />

                    <Link
                        to={getLink(
                            `/gastos-internos/crear?vehiculo=${vehiculo.id}`
                        )}
                        className='au-btn au-btn-icon au-btn--green au-btn--small'>
                        Registrar gasto
                    </Link>

                    <Link 
                        to={getLink(`/imprimir/vehiculos/${vehiculo.id}/gastos-internos${filtersQuery}`)}
                        target="_blank"
                        className='au-btn au-btn-icon au-btn--blue au-btn--small ml-2'>
                        <i className="zmdi zmdi-print"></i>
                    </Link>
                </div>
            </div>
            {loading ? (
                <Loader />
            ) : gastos.data?.length > 0 ? (
                <div>
                    <table className='table tickets-table'>
                        <thead>
                            <tr>
                                <th colSpan={4} className="text-right">Total</th>
                                <th className='text-right'><span style={{fontSize: '16px'}}>{formatCurrency(gastos.data.reduce((acc, gasto) => acc + parseFloat(gasto.total), 0))}</span></th>
                            </tr>
                            <tr>
                                <th>Fecha</th>
                                <th>Descripción</th>
                                <th>Categoría</th>
                                <th className='text-right'>Cantidad</th>
                                <th className='text-right'>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gastos.data.map((gasto) => {
                                const unidades = gasto.items?.reduce((acc, item) => {
                                    const key = item.item?.unidad?.toUpperCase() || '';

                                    if (!Object.hasOwn(acc, key)) {
                                        acc[key] = 0;
                                    }

                                    acc[key] += parseFloat(item.cantidad);

                                    return acc;
                                }, {});
                                const cantidades = Object.entries(unidades || {}).map(([unidad, cantidad]) => `${cantidad} ${unidad}`.trim()).join(', ');

                                return <tr key={gasto.id}>
                                    <td>{gasto.fecha}</td>
                                    <td>
                                        {gasto.suplidor?.nombre}
                                        {gasto.items.map(item => (<div>
                                            <small>{item.descripcion} - {formatCurrency(item.total)}</small>
                                        </div>))}
                                    </td>
                                    <td>{gasto.categorias.map((categoria) => categoria.nombre).join(', ') }</td>

                                    <td className='text-right'>
                                        {cantidades}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(gasto.total)}
                                    </td>
                                </tr>;
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={4} className="text-right">Total</th>
                                <th className='text-right'><span style={{fontSize: '16px'}}>{formatCurrency(gastos.data.reduce((acc, gasto) => acc + parseFloat(gasto.total), 0))}</span></th>
                            </tr>
                        </tfoot>
                    </table>
                    <Pagination
                        links={gastos.links}
                        meta={gastos.meta}
                        getData={getGastos}
                    />
                </div>
            ) : (
                <div>No se han registrado gastos para este vehículo.</div>
            )}
        </div>
    );
};

export default Gastos;
